import React, { useEffect } from 'react'
import Styles from './styles.module.sass'
import HeaderSubMenu from 'newComponents/HeaderSubMenu';
import { useConsultaSaldoPage } from 'newHooks/useConsultaSaldoPage';
import AsideLayout from '../AsideLayout';
import ModalLoading from 'newComponents/Loading';
import { ROUTE } from 'constants/general';

const CreditoLayout = ({ children, setData = null, udCard, setOtherUDcard }) => {

  const route = ROUTE
  const {cardsService, setUdCard, loading, errorCode: errorCodeT , isMobile } = useConsultaSaldoPage({route})

  useEffect(()=>{
    if(udCard){
      setUdCard(udCard)
      setOtherUDcard(undefined)
    }
  },[udCard])

  useEffect(()=>{
    if(cardsService){
      setData(cardsService)
    }
  },[cardsService])


  return (
    <>
      <AsideLayout cardsService={cardsService} setUdCard={setUdCard} />

      <div className={Styles?.contCreditLayout}>
        <HeaderSubMenu />
        <div
          className={Styles?.moduleCardSubLayout}
        >{children}</div>
      </div>
      { loading && <ModalLoading />}
    </>
  );
}

export default CreditoLayout;